// Local diagnostics only. No request bodies, query values, tokens or user IDs.
const samples = [];
const now = () => typeof performance !== 'undefined' ? performance.now() : Date.now();
export const startScreenPerformance = (screen) => {
  const started = now();
  return () => recordScreenPerformance({ kind: 'screen', source: screen, durationMs: now() - started });
};
export const recordScreenPerformance = (sample) => {
  samples.push({ ...sample, at: Date.now() });
  if (samples.length > 200) samples.shift();
};
export const getScreenPerformance = () => samples.map(sample => ({ ...sample }));
export const clearScreenPerformance = () => { samples.length = 0; };
if (typeof window !== 'undefined' && process.env.REACT_APP_PERFORMANCE_DIAGNOSTICS === 'true') {
  window.atmScreenPerformance = { read: getScreenPerformance, clear: clearScreenPerformance };
}
